import { DistributorPrice } from 'types/api/distributor.type';

import { Item } from './components/Item';

type ProductsProps = {
  products: DistributorPrice[];
  season: string;
  zone: string;
};

export function Products(props: ProductsProps): React.ReactElement {
  const { products, season, zone } = props;

  const productsItems = products?.map((item) => (
    <Item season={season} zone={zone} key={item.id} {...item} />
  ));

  return <div>{productsItems}</div>;
}
